import React from "react";
import { OptionSelector, TextInputBox } from "src/components/ui/inputs";
import { VendorShipmentDetails } from "src/types/database/vendor";

interface Props {
  shipmentDetails: VendorShipmentDetails;
  onFieldChange: (field: keyof VendorShipmentDetails, value: any) => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
}

const BusinessInfoSection: React.FC<Props> = ({ shipmentDetails, onFieldChange, getFieldErrorMessage }) => {
  return (
    <div className="p-6 space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <TextInputBox
            id="ops-poc"
            label="Ops POC"
            value={shipmentDetails.opsPOC || ""}
            onChange={(value: string) => onFieldChange("opsPOC", value)}
            error={getFieldErrorMessage("opsPOC")}
          />
        </div>

        <div>
          <TextInputBox
            id="ein"
            label="EIN / EORI"
            value={shipmentDetails.ein || ""}
            onChange={(value: string) => onFieldChange("ein", value)}
            error={getFieldErrorMessage("ein")}
          />
        </div>

        <div>
          <TextInputBox
            id="inco-terms-place"
            label="Incoterms Named Place"
            value={shipmentDetails.incoTermsPlace || ""}
            onChange={(value: string) => onFieldChange("incoTermsPlace", value)}
            error={getFieldErrorMessage("incoTermsPlace")}
          />
        </div>
      </div>

      <div>
        <TextInputBox
          id="notes"
          label="Notes"
          value={shipmentDetails.notes || ""}
          onChange={(value: string) => onFieldChange("notes", value)}
          error={getFieldErrorMessage("notes")}
          multiline
          rows={3}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-secondary-700">CI Required</label>
          <OptionSelector
            options={["NO", "YES"]}
            onSelect={(option) => onFieldChange("ciRequired", option === "YES")}
            value={shipmentDetails.ciRequired ? "YES" : "NO"}
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-secondary-700">BOL Required</label>
          <OptionSelector
            options={["NO", "YES"]}
            onSelect={(option) => onFieldChange("bolRequired", option === "YES")}
            value={shipmentDetails.bolRequired ? "YES" : "NO"}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessInfoSection;
